(function ($) {
    'use strict';

    $( document ).on( 'click', '.conf-room-info-toggle', function(){

        $(this).toggleClass('active');
        $(this).next().slideToggle();

    });

}(jQuery));


